// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2HdXV","inner":"Footer_inner__3rpe8","nextIcon":"Footer_nextIcon__3Et_4","innerLeft":"Footer_innerLeft__3NYYy"};